export default "__VITE_PUBLIC_ASSET__eb08cf90__"